
































































































import {
  Component, mapState, Watch, mixins, EventBus,
} from '@samclick-commons';
import SamclickMixins from '@/utils/mixins';
import { _filter, _includes } from '@samclick-lodash';
import AddCampaignGroup from './AddCampaignGroup.vue';
import AddCampaign from './AddCampaign.vue';
import {
  CampaignStore, CommonsStore, Payload, AuthorizationStore,
} from '@samclick-store-factory';
import { sortString } from '@/utils/common-utils';

class CampaignTabState {
  name: string = ''

    id: string = ''

    status: number | string = ''

    groupID: number | string = ''

    group: string = ''

  advertisementCategoryId: string | number = ''
}

const tag = new Map([
  ['1', 'success'],
  ['2', 'danger'],
]);

@Component({
  /**
   * Imported components
   * */
  components: { AddCampaignGroup, AddCampaign },
  /**
   * Stores values
   * */
  computed: {
    ...mapState({
      loading: (state: any) => state.campaign.campaignStore.loading,
      campaignList: (state: any) => state.campaign.campaignStore.campaignList,
      campaignStatus: (state: any) => state.commons.commonsStore.campaignStatus,
      campaignGroup: (state: any) => state.commons.commonsStore.campaignGroup,
    }),
  },
  /**
   * Component properties
   * */
  props: {},
})
export default class CampaignTab extends mixins(SamclickMixins) {
  /**
   * Local state
   * */
    state = new CampaignTabState();

    payloadTemp = {}

  /**
   * Watchers
   * */
  @Watch('componentState.var')
    sampleWatcher(newVal: string, oldVal: string) {

    }

  /**
   * Methods
   * */

  toggleCampaign(row: object = {}) {
    this.$refs.campaign.toggleDialog(true, row);
  }

  search(searchFromBtn: boolean = false) {
    let payload = this.payloadTemp;
    const {
      id, name, groupID, advertisementCategoryId, status,
    } = this.state;

    if (searchFromBtn) {
      payload = {
        id,
        name,
        groupId: groupID,
        advertisementCategoryId,
        status,
      };

      this.payloadTemp = payload;
    }

    payload.affiliateId = AuthorizationStore.currentLoggedUserInState.id;

    CampaignStore.getCampaignList(new Payload(payload));
  }

  loadDependency() {
    CommonsStore.getCampaignGroups(new Payload({ affiliateId: AuthorizationStore.currentLoggedUserInState.id }));
    this.search(false);
  }

  reset() {
    this.state = new CampaignTabState();
    this.search(true);
  }

  getTagType(status: number) {
    return tag.get(status.toString());
  }

  getCampaignStatusDescription(status: number) {
    return CommonsStore.campaignStatus(status).label;
  }

  sortByStatus(a: any, b: any) {
    return sortString(this.getCampaignStatusDescription(a.status), this.getCampaignStatusDescription(b.status));
  }

  get campaign() {
    return CampaignStore.campaign;
  }

  /**
   * Computed
   * */
  get activeCampaignGroup() {
    return CommonsStore.activeCampaign;
  }

  get advertisementCategories() {
    return CommonsStore.allAdvertisementCategories;
  }

  getAdvertisementCategoryName(advertisementCategoryId: number) {
    return CommonsStore.advertisementCategoryName(advertisementCategoryId);
  }

  /**
   * Lifecycle hooks
   * */
  created() {
    EventBus.$on('campaign-tab-search', () => {
      this.search(false);
    });
  }

  mounted() {
    this.loadDependency();
    CommonsStore.fetchAllAdsCategory();
  }

  beforeUpdate() {}
}
